import React from "react";

const SelectArrowIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3428_10144"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect
          x="20"
          width="20"
          height="20"
          transform="rotate(90 20 0)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_3428_10144)">
        <path
          d="M1.66659 6.68754L3.14575 5.20837L9.99992 12.0625L16.8541 5.20837L18.3333 6.68754L9.99992 15.0209L1.66659 6.68754Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export default SelectArrowIcon;
